/*!
 *
 *  accordion.js
 *
 */

module.exports = function() {
	$('.faq_question').on('click',function(){
		$(this).toggleClass('-active');
		$(this).next('.faq_answer').stop(true, false).slideToggle();
	});
}